
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ACOAD',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ACOAD.vue